var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5335 6.20212L10.9945 6.73679C10.8076 6.91256 10.5895 7.00049 10.3404 7.00049C10.0863 7.00049 9.87065 6.91256 9.6933 6.73679L6.19961 3.27235L2.70592 6.7367C2.52857 6.91247 2.31293 7.0004 2.0589 7.0004C1.80973 7.0004 1.59162 6.91247 1.40474 6.7367L0.87278 6.20203C0.690666 6.02154 0.599609 5.80526 0.599609 5.55336C0.599609 5.29675 0.690755 5.08292 0.87278 4.91187L5.55259 0.271365C5.72518 0.0907803 5.94073 0.000488281 6.19961 0.000488281C6.45363 0.000488281 6.67166 0.0907803 6.85368 0.271365L11.5335 4.91187C11.7108 5.08773 11.7996 5.30156 11.7996 5.55336C11.7996 5.80053 11.7108 6.01672 11.5335 6.20212Z",
    fill: "#8B9695"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.f0c244defe8e351f24dcb26fc5cdd9b9.svg";
export { ForwardRef as ReactComponent };